/**
 * =============================================================================
 * fgwp.js
 * =============================================================================
 * Handle client-side of the FGWP mechanism.
 * 
 * See also:
 * 
 * - fgwp-modal.liquid (the FGWP modal)
 * - fgwp.liquid (the FGWP product page messaging)
 * - fgwp-cart-offcanvas.liquid (the FGWP minicart cart messaging)
 * - fgwp-line-item (the line item messaging once the FGWP has been added)
 * 
 * This extension also requires:
 * 
 * - a Shopify Script to ensure all thresholds have been met and the 
*    shipping location is domestic, and that only 1 FGWP line item is added.
 * =============================================================================
 */

var FGWP = {
  data: {
    selectors: {
      threshold: "[data-mp-fgwp-threshold]",
      threshold_attribute: "data-mp-fgwp-threshold",

      product_ids: "[data-mp-fgwp-products]",
      product_ids_attribute: "data-mp-fgwp-products",

      to_spend_amount: ".mp-fgwp-to-spend-amount",
      to_spend_message: ".mp-fgwp-to-spend-message",

      add_buttons: ".fgwp-modal-add",
      variant_select: "[data-fgwp-variant-select]",

      met_threshold_message: ".mp-fgwp-threshold-met"
    },

    threshold: null,
    product_ids: [],
    user_country: null,
    included_countries: null
  },

  /**
   * Setup the FGWP mechanism, listening for cart / minicart state, handling
   * FGWP modal interactions, etc.
   */
  onReady: function(){
    // FGWP not enabled
    if(document.querySelectorAll(".fgwp-container").length == 0){
      return;
    }

    document.addEventListener('geodata:loaded', this.handleGeodataLoaded.bind(this));
    
    // Data attributes from mp-misc-free-gift-with-purchase.liquid
    this.data.threshold = parseInt(document.querySelector(this.data.selectors.threshold).dataset.mpFgwpThreshold);
    this.data.product_ids = JSON.parse(document.querySelector(this.data.selectors.product_ids).dataset.mpFgwpProducts);
    this.data.included_countries = document.querySelector("[data-fgwp-included-countries]").dataset.fgwpIncludedCountries.split(",");
  
    console.log('[FGWP] Initialized');
  },

  handleGeodataLoaded: function(event) {
    var geodataJSON = event.detail.data;
    this.data.user_country = geodataJSON.country.iso_code;

    // Activate if applicable to this country
    if(this.data.included_countries.includes(this.data.user_country)){
      this.setupOffer();
    } else {
      console.log("[FGWP] Ignore - no locale match");
    }
  },

  setupOffer: function() {
    // Handle cart update
    document.addEventListener('minicart:rendered', this.handleCartUpdated.bind(this));

    // Handle events on the modal
    document.querySelector("[data-fgwp-variant-select]").addEventListener("change", this.handleGiftVariantSelect.bind(this));
    document.querySelectorAll(this.data.selectors.add_buttons).forEach(element => {
      element.addEventListener("click", this.addFreeGift.bind(this));
    });

    this.updateMessaging();
  },

  updateMessaging: function() {
    // Reveal FGWP messaging
    document.querySelectorAll("[data-fgwp]").forEach(element => {
      element.classList.remove("d-none");
    });
  },

  /**
   * Handle when the FGWP variant select changes - update the carousel to show the right image
   * @param {Event} e
   */
  handleGiftVariantSelect: function(e) {
    let carousel = bootstrap.Carousel.getInstance(document.querySelector("[data-fgwp-modal-slider]"));
    let selectedVariantID = e.target.value;
    let applicableSlideIndex = document.querySelector(`.carousel-item[data-variant-id="${selectedVariantID}"]`).dataset.index;
    carousel.to(applicableSlideIndex);
  },

  /**
   * Add the selected FGWP variant to the cart, if FR is found
   * @returns undefined
   */
  addFreeGift: function(e) {
    let closestTile = e.target.closest(".fgwp-modal-tile");
    let selectedVariant = closestTile.querySelector(this.data.selectors.variant_select).value;

    if(selectedVariant == ""){
      return;
    }

    // Add it to the cart
    let productToAdd = {"id": selectedVariant, "quantity": 1, "properties": {"_fgwp": true}};
    MP.Extensions.Cart.add(productToAdd);

    // Hide the FGWP modal
    document.querySelector('#fgwp-modal .btn-close').click();
  },

  /**
   * Check the newly updated cart and update messaging / trigger the FGWP modal
   * if the threshold has been met.
   * 
   * @param {Event} e 
   * @returns undefined
   */
  handleCartUpdated: function(e) {
    console.log('[FGWP] Cart updated');
    var that = this;

    // No cart items - do nothing
    var cartItems = e.detail.cart?.items;
    if(cartItems === undefined) {
      return;
    }

    // Check if the cart already has the FGWP product
    var hasItem = false;
    cartItems.forEach(function(e){
      if(that.data.product_ids.includes(e.product_id)){
        if(e.properties !== null && e.properties['_fgwp']){
          hasItem = true;
        }
      }
    });

    // Exclude certain products from eligible total - gift cards
    var eligibleTotal = 0;
    eligibleTotal = cartItems.reduce(function(previousValue, e) {
      if(e.gift_card === true){
        return previousValue;
      } else {
        return previousValue + e.final_line_price
      }
    }, eligibleTotal);

    // Determine action based on cart state
    if(hasItem){
      // No longer required - updates dynamically from server in Liquid
    } else if (eligibleTotal >= this.data.threshold){
      // Show the prompt to add the FGWP 
      this.triggerPrompt();
    }
    console.log('[FGWP] Trigger messaging');
    this.updateMessaging();
  },


  /**
   * Show the FGWP modal, if it's not already been shown (i.e. no cookie set)
   * 
   * @returns undefined
   */
  triggerPrompt: function() {      
    // Only show the FGWP modal once, when the cart initially goes over the threshold
    var notShown = Cookies.get('fgwp-prompt-shown') === undefined;
    if(notShown){
      setTimeout(function() {
        document.querySelector("#fgwp-modal-open").click();
        Cookies.set('fgwp-prompt-shown', "true");
      }, 500);
    }
  }
};

export default FGWP;